import { Group, TextInput, Button } from '@mantine/core'
import { IconSearch, IconFilter, IconChevronDown, IconChevronUp, IconPlus } from '@tabler/icons-react'

export interface UsersToolbarProps {
  searchQuery: string
  onSearchChange: (value: string) => void
  filtersOpen: boolean
  onToggleFilters: () => void
  activeFilterCount: number
  onNewUser: () => void
}

export function UsersToolbar({
  searchQuery,
  onSearchChange,
  filtersOpen,
  onToggleFilters,
  activeFilterCount,
  onNewUser,
}: UsersToolbarProps) {
  const ChevronIcon = filtersOpen ? IconChevronUp : IconChevronDown

  return (
    <Group justify="space-between">
      <Group gap="sm">
        <TextInput
          placeholder="Buscar por nome, email, role..."
          leftSection={<IconSearch size={16} />}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.currentTarget.value)}
          style={{ width: 320 }}
          size="sm"
        />
        <Button
          variant="outline"
          size="sm"
          leftSection={<IconFilter size={14} />}
          rightSection={<ChevronIcon size={14} />}
          onClick={onToggleFilters}
        >
          {activeFilterCount > 0 ? `Filtros (${activeFilterCount})` : 'Filtros'}
        </Button>
      </Group>
      <Button leftSection={<IconPlus size={16} />} onClick={onNewUser}>
        Novo Usuário
      </Button>
    </Group>
  )
}
